export default __webpack_public_path__ + "355a8a3.png";